import { render, staticRenderFns } from "./MasterCardIcon.vue?vue&type=template&id=9067a6ec"
import script from "./MasterCardIcon.vue?vue&type=script&lang=js"
export * from "./MasterCardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports